// Ablage im Cookie (Login-Token, Login-Flag) und im localStorage (Profil,
// Einstellungen, Sprache). Wer eingeloggt ist, entscheidet session.js -
// die Seiten lesen is_loggedin nicht mehr selbst.

export function writeItem(itemKey, itemVal, storageType) {
    if (storageType === "cookie") {
        document.cookie = itemKey + "=" + (itemVal || "") + "; path=/";
    }
    if (storageType === "localStorage") {
        window.localStorage.setItem(itemKey, itemVal);
    }
    return true;
}

export function readItem(itemKey, storageType) {
    let itemVal = "";

    if (storageType === "cookie") {
        const nameEQ = itemKey + "=";
        for (let c of document.cookie.split(";")) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) itemVal = c.substring(nameEQ.length);
        }
    }

    if (storageType === "localStorage") {
        itemVal = window.localStorage.getItem(itemKey);
    }

    if (itemVal === null) itemVal = "";
    return itemVal;
}

/** Wert einer Frontend-Einstellung aus dem Login (settings_key -> settings_value), sonst "". */
export function checkSettings(searchkey) {
    const raw = readItem("settings", "localStorage");
    if (raw === "") return "";

    let settings;
    try {
        settings = JSON.parse(raw);
    } catch {
        return "";
    }

    const hit = settings.find((s) => s.settings_key === searchkey);
    return hit ? hit.settings_value : "";
}
